import React, {Component} from 'react'
import Table from '../../../tables/reactable/DefaultTable'

class SkillVendorList extends Component {
  constructor() {
    super()
    this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this)
    this.state = {
      itemsPerPage: 10,
      openBtnVisible: true,
      openBtnLabel: 'View'
    }
    this.columns = [
      'AvatarImage',
      'FullName',
      'ProdubNumber',
      'ActiveProfiles'
    ]
    this.columnNames = [
      '',
      'Full name',
      'Number',
      'Active profiles'
    ]
  }

  onChangeItemsPerPage(e) {
    e.preventDefault()
    this.setState({
      itemsPerPage: e.target.value
    })
    return false
  }

  render() {
    let items = this.props.items.map(item => {
      return Object.assign({}, item, {
        AvatarImage: item.AvatarImageUrl ? (<img src={item.AvatarImageUrl} style={{width: '50px'}} className="rounded-circle" alt="" />) : (null)
      })
    });

    return (
      <div>
        <Table
          items={items}
          columns={this.columns}
          columnNames={this.columnNames}
          itemsPerPage={this.state.itemsPerPage}
          searchVisible={false}
          onChangeItemsPerPage={this.onChangeItemsPerPage}
          openBtnVisible={this.state.openBtnVisible}
          openBtnLabel={this.state.openBtnLabel}
          openBtnHref="/talents/{NavigationParam}/overview"
          sortable={[
            'FullName',
            'ProdubNumber',
            'ActiveProfiles'
          ]}
          defaultSort={{column: 'FullName', direction: 'asc'}}
          selectPerPageCss={"-3.35rem"}
        />
      </div>
    )
  }
}

export default (SkillVendorList)
